export default __webpack_public_path__ + "static/screen-1-585e994fae2a9f62dc6b253a4de4173b.jpg";